// extracted by mini-css-extract-plugin
module.exports = {"card":"card--3Jcdc","card__divContent":"card__divContent--2OPdD"};